import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InvestmentsService {
  constructor(private http: HttpClient) {}

  getInvestmentsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/investments`);
  }

  updateInvestmentsData(
    formsId: number,
    investmentsId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/investments/${investmentsId}`,
      data
    );
  }
}
